import React, { useState, useEffect } from "react";
import { FaBell, FaMapMarkerAlt, FaPhoneAlt, FaExclamationTriangle, FaClock, FaKeyboard, FaMicrophone, FaPaperPlane } from "react-icons/fa";
import "./SOS.css";
import NavUser from "../components/NavUser";
import SEO from "../components/SEO";

function SOS() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [location, setLocation] = useState({ lat: 6.9271, lng: 79.8612 });
  const [address, setAddress] = useState("Fetching location...");
  const [specialRequest, setSpecialRequest] = useState("");


  // Update digital clock
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Get user location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const newLocation = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };
        setLocation(newLocation);

        // Reverse Geocode → Convert lat/lng to address
        fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${newLocation.lat}&lon=${newLocation.lng}`
        )
          .then((res) => res.json())
          .then((data) => setAddress(data.display_name))
          .catch(() => setAddress("Unable to fetch address"));
      },
      (err) => {
        console.error(err);
        setAddress("Location access denied.");
      }
    );
  }, []);

  const emergencyNumbers = [
    { number: "119", title: "GENERAL EMERGENCY", desc: "All emergencies", color: "red" },
    { number: "118", title: "POLICE", desc: "Police emergency", color: "blue" },
    { number: "110", title: "AMBULANCE", desc: "Medical emergency", color: "green" },
    { number: "1990", title: "SUWA SERIYA", desc: "Free ambulance", color: "orange" }
  ];

  return (
    <div className="agent-page sos-page-bg">
      <SEO
        title="Sri Lanka Tourist Emergency SOS & Quick Dial Numbers | Soloway"
        description="Emergency tourist police 1912, ambulance 1990, and rapid safety assistance directory for travelers in Sri Lanka on Soloway."
        canonicalPath="/emergency"
      />
      <NavUser />
      
      <div className="sos-hero">
        <div className="sos-pulse-container">
          <div className="pulse-ring"></div>
          <FaExclamationTriangle className="sos-hero-icon" />
        </div>
        <h1>Emergency Assistance</h1>
        <p>Your safety is our priority. Get help instantly.</p>
        <div className="sos-hero-time">
          <FaClock /> {currentTime.toLocaleTimeString()}
        </div>
      </div>

      <div className="agent-container">
        <div className="sos-main-grid">
          {/* Emergency Numbers */}
          <div className="sos-left-panel">
            <div className="agent-card">
              <div className="section-title">
                <FaPhoneAlt /> Quick Dial
              </div>
              <div className="sos-grid">
                {emergencyNumbers.map((item, index) => (
                  <EmergencyCard key={index} {...item} />
                ))}
              </div>

              <div className="sos-full-list">
                <h4 className="sub-title">Directory</h4>
                <EmergencyList title="Tourist Police" number="1912" />
                <EmergencyList title="Fire Brigade" number="110" />
                <EmergencyList title="General Emergency" number="119" />
                <EmergencyList title="Police Emergency" number="118" />
              </div>
            </div>

            <div className="agent-card">
              <div className="section-title">
                <FaKeyboard /> Request Assistance
              </div>
              <div className="form-group">
                <textarea
                  className="premium-textarea"
                  placeholder="Describe your emergency or specific needs..."
                  value={specialRequest}
                  onChange={(e) => setSpecialRequest(e.target.value)}
                  rows="4"
                />
              </div>
              <div className="sos-action-buttons">
                <button className="sos-voice-btn-premium">
                  <FaMicrophone /> Record Voice
                </button>
                <button className="sos-alert-btn-premium">
                  <FaPaperPlane /> Send Emergency Alert
                </button>
              </div>
            </div>
          </div>

          {/* Location Panel */}
          <div className="sos-right-panel">
            <div className="agent-card">
              <div className="section-title">
                <FaMapMarkerAlt /> Your Real-time Location
              </div>
              <div className="sos-address-box">
                <div className="address-icon"><FaMapMarkerAlt /></div>
                <div className="address-text">{address}</div>
              </div>
              <div className="sos-map-wrapper">
                <iframe
                  title="current-location"
                  src={`https://maps.google.com/maps?q=${location.lat},${location.lng}&hl=es;z=15&output=embed`}
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SOS;

// Emergency Grid Card Component
function EmergencyCard({ number, title, desc, color }) {
  return (
    <div className="sos-card" onClick={() => (window.location.href = `tel:${number}`)}>
      <div className="sos-card-number" style={{ color }}>{number}</div>
      <div className="sos-card-title">{title}</div>
      <div className="sos-card-desc">{desc}</div>
    </div>
  );
}

// Emergency List Item Component
function EmergencyList({ title, number }) {
  return (
    <div className="sos-list-item">
      <span>{title}</span>
      <span className="call-link" onClick={() => (window.location.href = `tel:${number}`)}>
        {number}
      </span>
    </div>
  );
}
